import { render, staticRenderFns } from "./ImsTable.vue?vue&type=template&id=1ba6e0de&scoped=true"
import script from "./ImsTable.vue?vue&type=script&lang=js"
export * from "./ImsTable.vue?vue&type=script&lang=js"
import style0 from "./ImsTable.vue?vue&type=style&index=0&id=1ba6e0de&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ba6e0de",
  null
  
)

export default component.exports